import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';
import { Trans } from '@lingui/react/macro';

import { useComboboxContext } from '@/components/Form/pickers/primitives/combobox/ComboboxContext';
import { Spinner } from '@/components/loaders';
import { cn } from '@/lib/utils';

export type ComboboxStatusProps = ComboboxPrimitive.Status.Props;

const ComboboxStatus = ({ className, ...props }: ComboboxStatusProps) => {
  const { error, isLoading } = useComboboxContext();

  const getStatus = () => {
    if (isLoading) {
      return (
        <>
          <Spinner size="xs" variant="spoke" />
          <Trans>Searching...</Trans>
        </>
      );
    }

    if (error) {
      return <Trans>Unable to load items, please refresh and try again</Trans>;
    }

    return null;
  };

  return (
    <ComboboxPrimitive.Status
      className={cn(
        'flex items-center gap-2 px-3 py-2 text-sm text-gray-500 italic empty:hidden',
        className,
      )}
      {...props}
    >
      {getStatus()}
    </ComboboxPrimitive.Status>
  );
};

export default ComboboxStatus;
